<label class="ui-checkbox" [class.ui-checkbox--disabled]="disabled">
  <input
    class="ui-checkbox__input"
    type="checkbox"
    [checked]="checked"
    [disabled]="disabled"
    [id]="id || null"
    (change)="toggle($event)"
  />
  <span class="ui-checkbox__box" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  </span>
  <span class="ui-checkbox__text">
    @if (label) {
      <span class="ui-checkbox__label">{{ label }}</span>
    }
    @if (hint) {
      <span class="ui-checkbox__hint">{{ hint }}</span>
    }
  </span>
</label>
